@if (state() === 'COUNTDOWN') {
  <rid-reading-countdown #countdown />
}

<p
  class="font-family-din text-text-primary rounded-md border-2 border-slate-300 bg-white px-4 py-3 text-3xl transition-opacity select-none"
  [class]="{
    'opacity-10': state() === 'BLANK',
  }"
>
  @for (char of text(); track $index) {
    <span
      class="inline-block whitespace-pre"
      [style.transition]="'opacity ' + char.duration + 'ms ease-out, scale ' + char.duration + 'ms ease-out'"
      [style.opacity]="char.opacity"
      [style.scale]="char.scale"
      >{{ char.text }}</span
    >
  }
</p>

<div class="absolute inset-0 overflow-hidden rounded-md">
  <ng-content></ng-content>
</div>
